import * as React from "react";
import type { SVGProps } from "react";
const SvgOrdersIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    className="orders_icon_svg__icon"
    viewBox="0 0 1024 1024"
    {...props}
  >
    <path
      fill="currentColor"
      d="M256 85.333a128 128 0 0 0-128 128v597.334a128 128 0 0 0 128 128h512a128 128 0 0 0 128-128V213.333a128 128 0 0 0-128-128H256zm-42.667 128A42.667 42.667 0 0 1 256 170.667h512a42.667 42.667 0 0 1 42.667 42.666v597.334A42.667 42.667 0 0 1 768 853.333H256a42.667 42.667 0 0 1-42.667-42.666V213.333zm128 426.667A42.667 42.667 0 0 1 384 597.333h256a42.667 42.667 0 1 1 0 85.334H384A42.667 42.667 0 0 1 341.333 640zm0-256A42.667 42.667 0 0 1 384 341.333h256a42.667 42.667 0 1 1 0 85.334H384A42.667 42.667 0 0 1 341.333 384z"
    />
  </svg>
);
export default SvgOrdersIcon;
